import React from 'react';
import { Countdown } from '@noths/polaris-client-ribbons-design-system';
import { getTimeNHoursBefore } from '@noths/polaris-client-utils';

import * as styles from './DepartmentBanner.styles';

export interface DepartmentBannerProps {
  backgroundColor: string;
  countdown?: {
    endDate: string;
    message: string;
    threshold: number;
  };
  linkHref?: string;
  message: string;
  promoCode?: string;
  textColor?: 'Light' | 'Dark';
}

export const DepartmentBanner = ({
  backgroundColor,
  countdown,
  linkHref,
  message,
  promoCode,
  textColor = 'Light',
}: DepartmentBannerProps) => {
  const tokenRegex = /({promocode}|{countdown})/gi;
  const showCountdown =
    countdown && Date.now() > getTimeNHoursBefore(countdown.endDate, countdown.threshold);
  const parts = showCountdown ? countdown.message.split(tokenRegex) : message.split(tokenRegex);

  const renderedMessage = parts.map((part, index) => {
    const key = `part-${index}`;

    if (part.toLowerCase() === '{promocode}' && promoCode) {
      return promoCode;
    }

    if (part.toLowerCase() === '{countdown}' && countdown) {
      return <Countdown endDateTime={countdown.endDate} key={key} />;
    }

    return part;
  });

  return (
    <div
      css={[styles.root, textColor === 'Light' ? styles.lightText : styles.darkText]}
      style={{ backgroundColor }}
    >
      {linkHref ? <a href={linkHref}>{renderedMessage}</a> : <span>{renderedMessage}</span>}
    </div>
  );
};
